$.fn.animateCSS = function( options ) {
  var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
  var self = this;
  var set = $.extend({
    delay: 0,
    stepDelay: 200,
    style: 'fadeInUp',
    waitFor: null,
    revert: false,
    removeStyle: false,
    before: function() {},
    after: function() {} // this one fire 2 times
  }, options);

  function setDelay(item, index) {
    setTimeout(function(){
      $(item)
        .addClass('animated ' + set.style);

      if (set.removeStyle) {
        $(item).one(animationEnd, function() {
          $(this).removeClass(set.style);
        })
      }
    }, set.delay + (index * set.stepDelay));
  }

  function getLast(el, index) {
    var len = $(el).length;
    if ( index === len - 1 ) {
      $(el).one(animationEnd, function(){
        set.after();
      })
    }
  }

  function animate(el) {
    set.before();

    if ( set.revert ) {
      $($(el).get().reverse()).each(function(i){
        setDelay(this, i);
      });
    } else {
      $(el).each(function(i){
        setDelay(this, i);
        getLast(el, i);
      });
    }
  }

  if ( set.waitFor !== null ) {
    $(set.waitFor).one(animationEnd, function(){
      return animate(self);
    });
  } else {
    return animate(self);
  }
};
// end animateCSS

$.fn.replaceSrc = function() {
  return $(this).each(function(){
    var src = $(this).attr('data-src');
    $(this).attr('src', src);
  });
};
